export default [
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/pages/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/pages/error/Error.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/hub",
    name: "hub",
    component: () => import("@/views/pages/hub/Hub.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/new-password",
    name: "new-password",
    component: () =>
      import("@/views/pages/authentication/login/NewPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/pages/authentication/login/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/select-brand",
    name: "select-brand",
    component: () => import("@/views/pages/authentication/login/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/change-password",
    name: "change-password",
    component: () => import("@/views/pages/authentication/login/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/forget-password",
    name: "forget-password",
    component: () =>
      import("@/views/pages/authentication/login/ForgetPasswordMain.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/landing",
    name: "landing",
    component: () => import("@/views/pages/landing/Landing.vue"),
  },
  {
    path: '/otp',
    name: 'otp',
    component: () => import('@/views/pages/authentication/login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
      redirectIfLoggedIn: true,
  },
  {
    path: '/version',
    name: 'version',
    component: () => import('@/views/pages/version/Version.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
      redirectIfLoggedIn: true,
  }
];
